import PropTypes from "prop-types";
import { Box, Grid, Chip, alpha } from "@mui/material";
import { Toll, AccountBalance } from "@mui/icons-material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";

const StatChip = ({ icon, label, value, color }) => (
  <Chip
    icon={icon}
    label={`${label}: ${value}`}
    sx={{
      bgcolor: alpha(color, 0.08),
      color,
      fontWeight: 600,
      fontSize: "0.75rem",
      border: `1px solid ${alpha(color, 0.3)}`,
      height: 30,
      "& .MuiChip-icon": { color },
    }}
  />
);

StatChip.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
};

const ConfigPeajesHeader = ({ totalConcesiones, totalPeajes, loading = false }) => (
  <MDBox
    sx={{
      p: 2.5,
      borderRadius: "12px 12px 0 0",
      background: "linear-gradient(120deg,#1e293b,#0b4f6c)",
      color: "#fff",
      mb: 0,
    }}
  >
    <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
      <Grid item xs={12} md={7}>
        <MDBox display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              bgcolor: alpha("#fff", 0.15),
              borderRadius: "10px",
              p: 1,
              display: "flex",
            }}
          >
            <Toll sx={{ fontSize: 26, color: "#fff" }} />
          </Box>
          <MDBox>
            <MDTypography variant="h5" color="white" fontWeight="bold">
              Configuración de Peajes
            </MDTypography>
            <MDTypography variant="body2" color="white" sx={{ opacity: 0.85 }}>
              Parámetros de liquidación, cortes horarios y consolidado por concesión
            </MDTypography>
          </MDBox>
        </MDBox>
      </Grid>
      <Grid item xs={12} md={5}>
        <MDBox
          display="flex"
          justifyContent={{ xs: "flex-start", md: "flex-end" }}
          gap={1}
          flexWrap="wrap"
        >
          <StatChip
            icon={<AccountBalance sx={{ fontSize: 16 }} />}
            label="Concesiones"
            value={loading ? "Consultando…" : totalConcesiones}
            color="#ffffff"
          />
          <StatChip
            icon={<Toll sx={{ fontSize: 16 }} />}
            label="Peajes"
            value={loading ? "Consultando…" : totalPeajes}
            color="#ffffff"
          />
        </MDBox>
      </Grid>
    </Grid>
  </MDBox>
);

ConfigPeajesHeader.propTypes = {
  loading: PropTypes.bool,
  totalConcesiones: PropTypes.number.isRequired,
  totalPeajes: PropTypes.number.isRequired,
};

export default ConfigPeajesHeader;
